import React from 'react';
import './OneLineSection.scss';

const OneLineSection = (props) => (
    <section className={`one-line-section theme-${props.theme} ${props.className}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2>{props.title}</h2>
          </div>
          <div className="item col-12">
            {
              props.content || 
              <img
                className="full-image"
                src={props.image}
                alt=""
              />
            }
          </div>
        </div>
      </div>
    </section>
);

export default OneLineSection;